angular.module('admin.directives')

.directive('sortHeader', [function(){
  return {
    restrict: 'EA',
    controllerAs: 'sortCtrl',
    bindToController: {
      onSort: '&',
      sortActive: '@',
      sortHeader: '@',
      sortOrder: '@',
    },
    scope: {},
    transclude: true,
    template: `
      <a href=""
        class="sort-header"
        ng-transclude
        ng-click="sortCtrl.sort()"
        ng-class="{
          'sort-header--active': sortCtrl.isActive(),
          'sort-header--asc': sortCtrl.sortOrder === 'ASC' && sortCtrl.isActive()
        }"
      ></a>
    `,

    controller: function(){
      let ctrl = this;

      ctrl.sort = function() {
        ctrl.onSort({sort: ctrl.sortHeader, order: ctrl.sortOrder});
      };

      ctrl.isActive = () => {
        return ctrl.sortHeader === ctrl.sortActive;
      };
    },
  }

}]);
